import TemplateView from '../TemplateView'

export default class SimpleDiv extends TemplateView {
    constructor({
        additionalClass = '',
        text = '',
    } = {}) {
        super()

        this.additionalClass = additionalClass
        this.text = text
    }

    templateHtml() {
        return "<div class='<%-additionalClass%>'><%-text%></div>"
    }
}



// WEBPACK FOOTER //
// ./web/js/components/SimpleDiv.js